export default "__VITE_ASSET__CgthhDy3__"